import type { ReactElement } from 'react'

import { QuestionList } from './QuestionList'
import { QuestionItemList } from './questionLists'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const FaqPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="FAQ"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <main>
        {QuestionItemList.map(({ questionTitle, questionList }) => (
          <QuestionList
            key={questionTitle}
            questionTitle={questionTitle}
            questionList={questionList}
          />
        ))}
      </main>
    </Layout>
  )
}

FaqPage.getLayout = function getLayout(page: ReactElement) {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'FAQ', path: '' },
  ]

  return (
    <>
      <Head
        title="FAQ"
        description="Frequently Asked Questions."
        ogp={{ url: 'en/ir/faq/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
